import { render } from "./LayoutsCol.vue?vue&type=template&id=0d23e549&scoped=true"
import script from "./LayoutsCol.vue?vue&type=script&lang=js"
export * from "./LayoutsCol.vue?vue&type=script&lang=js"

import "./LayoutsCol.vue?vue&type=style&index=0&id=0d23e549&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d23e549"]])

export default __exports__